import { ApiError } from '../api/client';

/** Human-readable message from any thrown value, favouring ApiError text. */
export function errorMessage(
  error: unknown,
  fallback = 'Something went wrong — please try again',
): string {
  if (error instanceof ApiError || error instanceof Error) {
    return error.message === '' ? fallback : error.message;
  }

  return fallback;
}

/** True when the failure is an HTTP conflict (409). */
export function isConflict(error: unknown): boolean {
  return error instanceof ApiError && error.status === 409;
}

/** Structured details from an ApiError, if any. */
export function errorDetails(error: unknown): Record<string, unknown> | undefined {
  return error instanceof ApiError ? error.details : undefined;
}
